import Limit from './Limit';

export default Limit;